import { _Props1, RotatingLines as RotatingLinesSrc } from "react-loader-spinner";

const RotatingLines = (props: _Props1) => <RotatingLinesSrc {...props}></RotatingLinesSrc>

export default RotatingLines;